import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-32 px-4 bg-brand-bgDarker relative overflow-hidden flex flex-col items-center text-center" data-id="element-51">
      {/* Subtle bottom glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-accent/20 blur-[100px] rounded-t-full pointer-events-none" data-id="element-52"></div>

      <div className="max-w-3xl mx-auto relative z-10 w-full" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-54">
          <h2 className="text-2xl md:text-4xl font-poppins font-black text-green-300 mb-8 uppercase tracking-widest text-sm" data-id="element-55">
            ⚠️ LA DECISIÓN
          </h2>

          <div className="space-y-4 text-xl md:text-3xl font-medium text-green-100" data-id="element-56">
            <p data-id="element-57">Podés seguir probando dietas…</p>
            <p className="font-bold text-white" data-id="element-58">
              O podés empezar a comer bien y bajar de peso de verdad.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/10 border border-white/20 backdrop-blur-sm rounded-3xl p-10 mb-20" data-id="element-59">
          <h3 className="text-2xl md:text-4xl font-poppins font-black text-brand-accentLight mb-4" data-id="element-60">
            🥗 SALUD EN TU PLATO
          </h3>
          <p className="text-lg md:text-xl font-medium text-white" data-id="element-61">
            No es dieta. Es saber qué comer.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-62">
          <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full text-xs tracking-widest uppercase mb-10 border border-white/20" data-id="element-63">
            🚀 CIERRE FINAL
          </div>

          <div className="space-y-4 text-2xl md:text-4xl font-poppins font-black mb-12 text-white" data-id="element-64">
            <p data-id="element-65">👉 El cambio empieza en tu plato</p>
            <p className="text-brand-accentLight" data-id="element-66">
              👉 Y hoy ya sabés cómo hacerlo
            </p>
          </div>

          <CTAButton href="https://salud-en-tu-plato.myshopify.com/cart/48180907081895:1" className="text-xl md:text-2xl py-6 px-12 w-full md:w-auto shadow-[0_0_40px_rgba(34,197,94,0.6)]" data-id="element-67">
            🔥 EMPEZÁ HOY
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}